export { default as Img200 } from './processed/200/DarkThe.jpg';
export { default as Img400 } from './processed/400/DarkThe.jpg';
export { default as Imgthumb } from './processed/thumb/DarkThe.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/DarkThe.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/DarkThe.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      196,
      137,
      70
    ],
    "_population": 2640,
    "_hsl": [
      0.0886243386243386,
      0.5163934426229508,
      0.5215686274509804
    ]
  },
  "LightVibrant": {
    "_rgb": [
      246,
      191,
      123
    ],
    "_population": 984,
    "_hsl": [
      0.0921409214092141,
      0.8723404255319152,
      0.7235294117647059
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      99,
      65,
      21
    ],
    "_population": 2883,
    "_hsl": [
      0.09401709401709402,
      0.65,
      0.23529411764705882
    ]
  },
  "Muted": {
    "_rgb": [
      164,
      132,
      92
    ],
    "_population": 1,
    "_hsl": [
      0.09259259259259262,
      0.2834645669291339,
      0.5019607843137255
    ]
  },
  "DarkMuted": {
    "_rgb": [
      76,
      68,
      44
    ],
    "_population": 3,
    "_hsl": [
      0.125,
      0.26666666666666666,
      0.23529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/DarkThe.js